import script from "./ProjectInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectInfoModal.vue?vue&type=style&index=0&id=5eaedb43&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eaedb43"]])

export default __exports__